export default __webpack_public_path__ + "static/media/brand-hermes.17665599.jpg";